module.exports = __webpack_public_path__ + "img/2.48430b17.svg";